import ReactDOM from "react-dom/client";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

// Context
import { ClientProvider } from "./ClientContext";

// Global Styles
import "rc-slider/assets/index.css";
import "./styles/index.scss";
import "./index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";

// Components
import App from "./App";
import ScrollToTop from "routers/ScrollToTop";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <ClientProvider>
        <BrowserRouter>
          <ScrollToTop /> {/* Scrolls to top on route changes */}
          <App />
        </BrowserRouter>
      </ClientProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

// Performance monitoring
reportWebVitals();